
import React, { useState, useContext } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Label, Button, FormGroup, FormText } from 'reactstrap';
import Select from 'react-select';
import { MenuContext } from './MenuSnooze';
import { calculateExpiry } from '../utils/commonSnoozeUtils';

const constants = require('../../../utils/domain/constants.js')
const localizationUtils = require('../../../utils/domain/localizationUtils.js')
const stringUtil = require('../../../utils/string/stringUtil.js')
const menuSnoozeViewUtil = require("./menuSnoozeUtil.js");
const translator = require("../../../utils/translator/translator");

function SnoozeDialogue(
    {
        showModal,
        snooze,
        onSnooze = () => { },
        onCancel = () => { }
    }
)
{
    let { selectBoxStyles } = useContext(MenuContext);
    selectBoxStyles = { ...selectBoxStyles, container: (base) => ({ ...base }) };
    
    const expiryOptions = [
        { value: "OneHour", label: translator.getLabel("one_hour") },
        { value: "TwoHour", label: translator.getLabel("two_hours") },
        { value: "FourHour", label: translator.getLabel("four_hours") },
        { value: "Today", label: translator.getLabel("today") },
        { value: "TwoDays", label: translator.getLabel("two_days") },
        { value: "ThreeDays", label: translator.getLabel("three_days") },
        { value: "Manual", label: translator.getLabel("manual") },
    ];

   const dispatchOptions = [
        { value: "DineIn", label: translator.getLabel("dine_in") },
        { value: "Delivery", label: translator.getLabel("delivery") },
        { value: "Collection", label: translator.getLabel("collection") },
        { value: "TakeAway", label: translator.getLabel("takeaway") },
    ];

    const venueOptions = localizationUtils.getApplicableVenues().map(venue => ({ value: venue.code, label: venue.code }));

    const selectedExpiryCaption = expiryOptions.find(expOpt => expOpt.value === snooze.expiryCaption) || { value: 'Manual', label: translator.getLabel("manual") };

    const selectedDispatchOptions = [];
    snooze.dispatchTypes.forEach(dispatchType =>
    {
        const dispatchSelectOpt = dispatchOptions.find(dispatchOpt => dispatchOpt.value === dispatchType);
        if (dispatchSelectOpt) 
        {
            selectedDispatchOptions.push(dispatchSelectOpt);
        }
    });

    const selectedVenueCodes = [];
    snooze.venueCodes.forEach(venueCode =>
    {
        const venueSelectOpt = venueOptions.find(venueOpt => venueOpt.value === venueCode);
        if (venueSelectOpt) 
        {
            selectedVenueCodes.push(venueSelectOpt);
        }
    })

    const [snoozeOptions, setSnoozeOptions] = useState({
        selectedExpiryCaption: selectedExpiryCaption,
        selectedDispatchOptions: selectedDispatchOptions,
        selectedVenueCodes: selectedVenueCodes,
        selectedExpiry: calculateExpiry(selectedExpiryCaption.value),
    });

    const submitBtnDisabled = stringUtil.isStringNullOrEmpty(snoozeOptions.selectedExpiryCaption) ? true : false;

    const handleSubmit = function ()
    {
        onSnooze(snoozeOptions);
    }

    const handleCancel = function ()
    {
        onCancel();
    }

    return (
        <Modal isOpen={showModal} centered size='lg'>
            <ModalHeader>{translator.getLabel("snooze_options")}</ModalHeader>
            <ModalBody>
                <div>
                    <FormGroup>
                        <Label>{translator.getLabel("expiry")}</Label>
                        <Select
                            styles={selectBoxStyles}
                            isClearable={false}
                            value={snoozeOptions.selectedExpiryCaption}
                            isSearchable={false}
                            options={expiryOptions}
                            onChange={(expOption) =>
                            {
                                const calculatedExpiry = menuSnoozeViewUtil.calculateExpiry(expOption.value);
                                setSnoozeOptions(prevState => ({ ...prevState, selectedExpiryCaption: expOption, selectedExpiry: calculatedExpiry }));
                            }}
                        />
                        <FormText color="muted">{translator.getLabel("choose_snooze_expiry")}</FormText>
                    </FormGroup>
                    <FormGroup>
                        <Label>{translator.getLabel("dispatch_types")}</Label>
                        <Select
                            styles={selectBoxStyles}
                            isSearchable={false}
                            value={snoozeOptions.selectedDispatchOptions}
                            options={dispatchOptions}
                            isClearable={false}
                            isMulti={true}
                            onChange={(dispatchOpts) =>
                            {
                                setSnoozeOptions(prevState => ({ ...prevState, selectedDispatchOptions: dispatchOpts }));
                            }}
                        />
                        <FormText color="muted">{translator.getLabel("choose_dispatch_type")}</FormText>
                    </FormGroup>
                    <FormGroup>
                        <Label>{translator.getLabel("venues")}</Label>
                        <Select
                            styles={selectBoxStyles}
                            value={snoozeOptions.selectedVenueCodes}
                            options={venueOptions}
                            isSearchable={false}
                            isClearable={false}
                            isMulti={true}
                            onChange={(venueOpts) =>
                            {
                                setSnoozeOptions(prevState => ({ ...prevState, selectedVenueCodes: venueOpts }))
                            }}
                        />
                        <FormText color="muted">{translator.getLabel("choose_venue")}</FormText>
                    </FormGroup>
                </div>
            </ModalBody>
            <ModalFooter>
                <div className='d-flex flex-row-reverse gap-3'>
                    <Button className='btn-ok' onClick={handleSubmit} disabled={submitBtnDisabled}>{translator.getLabel("done")}</Button>
                    <Button className='btn-cancel' onClick={handleCancel}>{translator.getLabel("cancel")}</Button>
                </div>
            </ModalFooter>
        </Modal>
    )
}

export default SnoozeDialogue;